<div class="p-2 max-w-4xl mx-auto bg-white rounded-lg shadow">
  <!-- Tab Navigation -->
  <div class="flex border-b border-gray-300">
    <button class="px-4 py-2 text-sm font-medium transition duration-200 border-b-2"
      [class.text-blue-600]="activeTab === 'builder'" [class.border-blue-600]="activeTab === 'builder'"
      [class.text-gray-500]="activeTab !== 'builder'" [class.border-transparent]="activeTab !== 'builder'"
      (click)="switchTab('builder')" style="cursor: pointer;">
      {{ label }}
    </button>
    <button class="px-4 py-2 text-sm font-medium transition duration-200 border-b-2"
      [class.text-blue-600]="activeTab === 'json'" [class.border-blue-600]="activeTab === 'json'"
      [class.text-gray-500]="activeTab !== 'json'" [class.border-transparent]="activeTab !== 'json'"
      (click)="switchTab('json')" style="cursor: pointer;">
      JSON
    </button>
  </div>

  <div class="mt-4">
    <!-- JSON Builder Tab -->
    <div *ngIf="activeTab === 'builder'" class="space-y-4">
      <!-- Empty State -->
      <div *ngIf="entries.length === 0" class="flex flex-col items-center justify-center py-8 text-gray-400">
        <lucide-icon name="list-x" class="w-12 h-12 mb-2"></lucide-icon>
        <p class="text-sm">Empty {{ label }} list</p>
        <button class="mt-4 px-4 py-2 bg-blue-500 text-white rounded text-sm shadow hover:bg-blue-600 transition"
          (click)="addEntry()" style="cursor: pointer;">
          + Add Entry
        </button>
      </div>

      <!-- Entry Rows -->
      <div *ngIf="entries.length > 0">
        <div *ngFor="let entry of entries; let i = index" class="flex items-center space-x-2 space-y-2">
          <!-- Delete Entry Button -->
          <button (click)="removeEntry(i)" class="text-gray-400 hover:text-red-500" style="cursor: pointer;">
            <lucide-icon name="trash-2" class="w-4 h-4"></lucide-icon>
          </button>

          <!-- Property Name -->
          <input type="text" [attr.id]="'property-' + i" placeholder="Property Name" [(ngModel)]="entry.key"
            (ngModelChange)="handleInputChange($event)"
            class="flex-1 w-[180px] border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400" />

          <!-- Type Selector -->
          <select [(ngModel)]="entry.type" (ngModelChange)="handleInputChange($event)"
            class="w-[120px] border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400">
            <option value="string">String</option>
            <option value="number">Number</option>
            <option value="boolean">Boolean</option>
            <option value="array">List</option>
          </select>

          <!-- Simple Value Field -->
          <input *ngIf="entry.type !== 'array'" type="text" [attr.id]="'value-' + i" placeholder="Value"
            [(ngModel)]="entry.value" (ngModelChange)="handleInputChange($event)"
            class="flex-1 w-[200px] border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400" />

          <!-- Array Fields -->
          <div *ngIf="entry.type === 'array'" class="flex flex-col w-full space-y-2">
            <!-- Array Items -->
            <div *ngFor="let field of entry.fields; let j = index" class="flex items-center space-x-2">
              <!-- Array Value Field -->
              <input *ngIf="entry.type === 'array'" type="text" [attr.id]="'array-' + i + '-' + j"
                placeholder="Array Value" [(ngModel)]="field.value" (ngModelChange)="handleInputChange($event)"
                class="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                style="width: calc(100% - 50px);" />
              <!-- Delete Array Item Button -->
              <button *ngIf="entry.fields" (click)="removeArrayField(entry.fields, j)"
                class="text-gray-400 hover:text-red-500" style="cursor: pointer;">
                <lucide-icon name="x" class="w-4 h-4"></lucide-icon>
              </button>
            </div>
            <!-- Add Array Value Button -->
            <button (click)="addArrayField(entry)"
              class="text-white text-sm bg-blue-500 rounded-md w-[160px] h-[29px] hover:bg-blue-600"
              style="cursor: pointer; align-self: start;">
              + Add List Value
            </button>
          </div>
        </div>

        <!-- Add Entry Button (when entries exist) -->
        <button class="mt-4 px-4 py-2 bg-blue-500 text-white rounded text-sm shadow hover:bg-blue-600 transition"
          (click)="addEntry()" style="cursor: pointer;">
          + Add Entry
        </button>
      </div>
    </div>

    <!-- JSON Preview Tab -->
    <div *ngIf="activeTab === 'json'" class="bg-white p-4 rounded-lg border border-gray-300">
      <textarea class="w-full h-48 p-2 font-mono text-sm" [value]="formattedJson" (change)="handleJsonChange($event)">
      </textarea>
    </div>
  </div>
</div>
